export default {
  nav: {
    home: 'Home',
    about: 'About',
    equipments: 'SLM Equipment',
    products: 'Products',
    factory: 'Factory',
    projects: 'Projects',
    news: 'News',
    contact: 'Contact',
  },
  footer: {
    quickLinks: 'Quick Links',
    company: 'Company',
    contact: 'Contact',
    getInTouch: 'Get In Touch',
    rights: 'Shandong Charmray Laser Technology Co., Ltd. All Rights Reserved.',
  },
  home: {
    tagline: 'A Leader in Industrial-Grade Metal 3D Printing Solutions',
    slogan: 'Focused on integrated innovative design and high-quality manufacturing of equipment, materials, processes, and structural functions.',
    exploreEquip: 'Explore Equipments',
    contactUs: 'Contact Us',
    coreAdvantages: 'Core Advantages',
    advantagesSub: 'Data-driven results powered by SLM technology and AI-enhanced manufacturing',
    whyChoose: 'Why Choose Charmray',
    darkFactory: 'Lights-Out Smart Factory',
    darkFactoryDesc: 'Unmanned intelligent production lines, 24/7 continuous operation, fully automated from powder to finished parts',
    timeSaved: 'Cycle Time Reduction',
    timeSavedValue: '70%',
    timeSavedDesc: 'No tooling required — print finished parts directly. From design to delivery, efficiency multiplied.',
    materialSaved: 'Material Efficiency',
    materialSavedValue: '>95%',
    materialSavedDesc: 'Additive near-net-shape manufacturing vs. only 10%–40% utilization with traditional subtractive methods.',
    precision: 'Forming Accuracy',
    precisionValue: '±0.05mm',
    precisionDesc: 'Micron-level metal printing accuracy with 0.01mm texture resolution and excellent surface quality.',
    autoDark: 'Lights-Out Ops',
    autoDarkValue: '24/7',
    autoDarkDesc: 'End-to-end automated unmanned operation with remote monitoring, intelligent scheduling, and maximum cost efficiency.',
    equipmentLineup: 'SLM Additive Manufacturing Equipment',
    equipmentSub: 'Metal powder bed fusion — customizable build sizes from 100mm to 1500mm',
    viewAllEquip: 'View All SLM Equipment →',
    applicationProducts: 'Application Products',
    productsSub: 'Professional 3D printing solutions across multiple industries',
    viewAllProd: 'View All Products →',
    globalFootprint: 'Global Manufacturing Footprint',
    footprintSub: '40,000m² workshop area across multiple production bases',
    m2: 'm² Workshop Area',
    bases: 'Production Bases',
    certs: 'System Certifications',
    learnFactory: 'Learn About Our Factory →',
    together: 'Together, We Win',
    togetherSub: 'We believe cooperation is about value co-creation, resource sharing, and mutual growth',
  },
  about: {
    title: 'ABOUT CHARMRAY',
    subtitle: 'Leading the future of industrial metal additive manufacturing',
    companyIntro: `Shandong Charmray Laser Technology Co., Ltd. is a high-tech enterprise specializing in high-end 3D printing equipment, 3D printing precision structural parts, laser additive manufacturing solutions and supporting intelligent systems.

Since its establishment in 2016, the company has been committed to independent R&D, manufacturing of complex structural parts, software development and technological innovation in the field of additive manufacturing. With a professional R&D team, strict quality control system and standardized production base, we provide global customers in high-end industries including industrial manufacturing, aerospace, automotive, medical, mold and education with high-performance, high-stability and high-reliability 3D printing equipment, customized intelligent solutions, flexible production lines and unmanned factory solutions.

The company's core products cover metal powder bed fusion printing equipment with a building size ranging from 100mm to 1500mm, various sizes of metal 3D printed parts and 3D printing software. All products comply with quality standards and have obtained authoritative certifications, ensuring excellent performance and long service life.

Shandong Charmray Laser is your reliable partner in intelligent manufacturing and advanced additive manufacturing solutions. We sincerely welcome customers from all over the world to cooperate for a better future.`,
    partnerMsg: 'Shandong Charmray Laser is your reliable partner in intelligent manufacturing and advanced additive manufacturing solutions. We sincerely welcome customers from all over the world to cooperate for a better future.',
    statsYears: 'Since 2016',
    statsLabel1: 'Years of Innovation',
    statsRange: '100–1500mm',
    statsLabel2: 'Build Size Range',
    statsCert: 'ISO / CE',
    statsLabel3: 'Certifications',
    statsGlobal: 'Global',
    statsLabel4: 'Service Network',
    timeline: 'Development Milestones',
    timelineSub: "Every milestone embodies the condensation of sweat and hard work. From startup to expansion — steady progress, continuous breakthroughs, unwavering original aspiration. The future will not let down this era; we will reach new heights together with our partners.",
    sending: 'Sending...',
    sendSuccess: 'Message sent successfully! We will get back to you soon.',
    sendError: 'Failed to send. Please email us directly.',
  },
  equipments: {
    title: 'SLM Additive Manufacturing Equipment',
    subtitle: 'Metal powder bed fusion — customizable build sizes from 100mm to 1500mm, non-standard customization available',
    requestQuote: 'Request Quote',
    backToList: '← Back to Equipments',
    notFound: 'Equipment Not Found',
    specs: {
      title: 'Technical Specifications',
      buildSize: 'Build Size',
      laser: 'Laser System',
      materials: 'Compatible Materials',
      accuracy: 'Forming Accuracy',
      efficiency: 'Build Efficiency',
      feedMethod: 'Powder Feed',
      spreadMethod: 'Powder Spreading',
      protectGas: 'Atmosphere',
      layerThickness: 'Layer Thickness',
      oxygenContent: 'O₂ Content',
      spotDiameter: 'Spot Diameter',
      partRemoval: 'Part Removal',
      scanSystem: 'Scan System',
      machineSize: 'Machine Size',
      weight: 'Weight',
      scanSpeed: 'Scan Speed',
      powerConsumption: 'Power Consumption',
      basePlatePreheat: 'Base Plate Preheat',
      dataFormat: 'Data Format',
      software: 'Software',
      note: 'Note: ① Excludes baseplate height; ② Depends on part size, shape, laser power & process params; ③ Theoretical data, actual dimensions subject to configuration.\n※ We reserve the right to update parameters without prior notice.',
      // W3500 Wire Plasma Arc specific
      positioningAccuracy: 'Positioning Accuracy',
      wireFeedRate: 'Wire Feed Rate',
      wireHeadCount: 'Wire Head Count',
      formingSpeed: 'Forming Speed',
    },
    applications: 'Application Fields',
    appPhotoPlaceholder: 'Application Photo',
    advantages: 'Equipment Advantages',
    advantageItems: [
      'Material waste rate below 6%',
      'Production cycle reduced by 70% on average',
      'AI-assisted design — significant improvements in precision and lightweight performance',
      'Reduced labor, material and design costs — cost savings of 40%+',
      'Intelligent, digital manufacturing with effective quality control',
      'Meter-scale large complex structures with customized one-piece forming',
    ],
  },
  products: {
    title: 'Application Products',
    subtitle: 'Professional 3D printing solutions across multiple industries',
    customSolution: 'Need a Custom Solution?',
    customDesc: 'Contact us to discuss your specific 3D printing requirements',
    getInTouch: 'Get In Touch',
  },
  factory: {
    title: 'Factory & Certifications',
    subtitle: '40,000m² workshop area — large-scale, standardized production capabilities',
    ourBases: 'Our Bases',
    basesSub: 'Masterpiece of craftsmanship, shining far and wide',
    facilities: 'Our Facilities',
    facilitiesSub: 'Production workshop, R&D center, testing equipment and office buildings',
    certifications: 'Certifications',
    certsSub: 'Authoritative certifications ensuring excellent performance and long service life',
    workshop: 'Production Workshop',
    rdCenter: 'R&D Center',
    testLab: 'Testing Lab',
    office: 'Office Building',
  },
  projects: {
    title: 'Projects',
    subtitle: 'Explore our cutting-edge 3D printing applications and solutions',
    rdAnimations: 'R&D Animations',
    animationsDesc: 'Visual demonstrations of our 3D printing technology and processes',
    animPlaceholder: '3D Printing Process Animation',
    interested: 'Interested in Cooperation?',
    interestedDesc: 'Contact us to discuss your project requirements',
  },
  news: {
    title: 'News & Events',
    subtitle: 'Latest updates from Charmray Laser',
    tctTitle: 'TCT Asia Exhibition',
    tctDesc: 'Charmray has been a regular exhibitor at TCT Asia (National Exhibition and Convention Center, Shanghai), showcasing full-scenario metal 3D printing solutions from standalone machines to automated production lines, covering shoe molds, tire molds, aerospace, and new energy vehicle applications.',
    tctNote: 'Visit Charmray\'s booth to experience cutting-edge additive manufacturing technology.',
    exhibition: 'exhibition',
    product: 'product',
    empty: 'No news available. Stay tuned.',
  },
  contact: {
    title: 'Contact Us',
    subtitle: 'Your reliable partner in intelligent manufacturing — we look forward to hearing from you',
    getInTouch: 'Get In Touch',
    contactIntro: 'We sincerely welcome customers from all over the world to cooperate for a better future.',
    phone: 'Phone',
    email: 'Email',
    wechat: 'WeChat',
    whatsapp: 'WhatsApp',
    wechatOfficial: 'Official WeChat',
    address: 'Address',
    toBeUpdated: 'To be updated',
    sendMessage: 'Send Us a Message',
    name: 'Name *',
    namePlaceholder: 'Your name',
    emailField: 'Email *',
    emailPlaceholder: 'your-email-address',
    company: 'Company',
    companyPlaceholder: 'Your company name',
    subject: 'Subject',
    selectSubject: 'Select a subject',
    equipment: 'Equipment Inquiry',
    productInquiry: 'Product / Application Inquiry',
    cooperation: 'Business Cooperation',
    other: 'Other',
    message: 'Message *',
    messagePlaceholder: 'Tell us about your needs...',
    send: 'Send Message',
    sent: 'Message Sent!',
  },
  common: {
    loading: 'Loading...',
    learnMore: 'Learn More →',
    viewAll: 'View All →',
    back: '← Back',
    stainlessSteel: 'Stainless Steel',
    toolSteel: 'Tool Steel',
    aluminumAlloy: 'Aluminum Alloy',
    titaniumAlloy: 'Titanium Alloy',
    nickelAlloy: 'Nickel Alloy',
    copperAlloy: 'Copper Alloy',
    pureCopper: 'Pure Copper',
    superalloy: 'Superalloy',
  },
  equipDesc: {
    s100: 'Compact metal additive 3D printer for precision small parts. Custom sizes available.',
    s130: 'Versatile metal additive 3D printer for small to medium precision components. Custom sizes available.',
    s180: 'Mid-size metal additive 3D printer covering S100/S130 specs. Available in customized 100×100×100mm 500W×1 or 130×130×100mm 500W×1 build sizes. Custom sizes available.',
    s250: 'Industrial metal additive 3D printer for medium-sized precision parts. Custom sizes available.',
    s350: 'CR-S350 is our independently developed small-medium format green-light metal 3D printing series equipment, meeting integrated forming needs of sub-millimeter ultra-thin walls and complex 3D conformal flow channels for highly reflective metals such as pure gold, pure copper, copper alloys. Standard equipped with 1 laser (optional 2 lasers), build size 250×250×350mm.',
    s420: 'CR-S420 is our independently developed medium-format metal 3D printing series equipment, meeting manufacturing needs for tire molds, industrial manufacturing and more. Standard equipped with 3 lasers (optional 4 lasers), supports aluminum alloy, titanium alloy, nickel-based superalloy, cobalt-chromium alloy, stainless steel, tool steel etc., with a build size of 420×300×400mm.',
    s460: 'CR-S460 is our independently developed medium-to-large format metal 3D printing equipment, designed to meet integrated structural-functional, high-precision and lightweight rapid manufacturing needs for UAVs, robotic components and mechanical manufacturing. Standard equipped with 4 lasers (optional 6 lasers), supports aluminum alloy, titanium alloy, nickel-based superalloy, cobalt-chromium alloy, stainless steel, tool steel etc., with a build size of 460×460×500mm.',
    m460: 'CR-M460 is our independently developed industrial-grade 6-laser dedicated shoe mold machine. Mature debugging technology, high-quality laser beams, and ultra-high repeat positioning accuracy ensure long-term stable operation without laser drift. Perfectly solves the complex traditional shoe mold manufacturing process, adapts to diverse production scenarios with efficient, high-intensity, high-quality continuous production. Standard equipped with 6 lasers, build size 460×430×150mm.',
    m600: 'CR-M600 is our independently developed second-generation dedicated shoe mold machine with upgraded 8-beam laser system, inheriting stable print quality and process data from the first generation while greatly improving print speed. Supports aluminum alloy, titanium alloy, nickel-based superalloy, cobalt-chromium alloy, stainless steel, tool steel etc., with a build size of 600×450×200mm.',
    s610: 'CR-S610 is our independently developed large-format metal 3D printing series equipment, designed to meet rapid manufacturing needs of ultra-large components with complex internal flow channels, overhanging structures, thin-walled surfaces and closed impeller structures in aerospace, nuclear power and marine fields. Standard equipped with 6 lasers (optional 4 lasers), supports aluminum alloy, titanium alloy, nickel-based superalloy, cobalt-chromium alloy, stainless steel, tool steel etc., with a build size of 610×610×800mm.',
    s650: 'CR-S650 is our independently developed large-format metal 3D printing series equipment, designed to meet rapid manufacturing needs of large-size components for UAVs and low-altitude economy fields. Standard equipped with 8 lasers, supports aluminum alloy, titanium alloy, nickel-based superalloy, cobalt-chromium alloy, stainless steel, tool steel etc., with a build size of 650×650×1000mm.',
    s850: 'CR-S850 is our independently developed large-format metal 3D printing series equipment, designed to meet rapid manufacturing needs of ultra-large components such as aerospace expansion sections, tail nozzles, combustion chambers and more. Standard equipped with 8 lasers, supports aluminum alloy, titanium alloy, nickel-based superalloy, cobalt-chromium alloy, stainless steel, tool steel etc., with a build size of 850×850×1500mm.',
    s1300: 'CR-S1300 is our independently developed ultra-large format metal 3D printing series equipment, meeting rapid manufacturing needs of extra-large industrial components in aerospace, wind power and nuclear fields. Standard equipped with 12 lasers (optional 16 lasers), supports aluminum alloy, titanium alloy, nickel-based superalloy, stainless steel, tool steel etc., with a build size of 1250×1250×1500mm.',
    s1500: 'CR-S1500 is our independently developed ultra-large format metal 3D printing series equipment, designed to meet the rapid manufacturing needs of meter-scale ultra-large components in aerospace, marine, nuclear power and other fields. Standard equipped with 16 lasers (optional 22 lasers), supports aluminum alloy, titanium alloy, nickel-based superalloy, cobalt-chromium alloy, stainless steel, tool steel and more, with a build size of 1500×1500×1500mm.',
    s2500: 'CR-S2500 is our independently developed ultra-large format metal 3D printing series equipment, meeting integrated manufacturing needs of ultra-large components in aerospace, industrial energy and marine/nuclear power fields. Standard equipped with 36 lasers (optional 64 lasers), supports aluminum alloy, titanium alloy, nickel-based superalloy, stainless steel, tool steel etc., with a build size of 2500×2500×2500mm.',
    w3500: 'CR-W3500 is a wire plasma arc intelligent additive manufacturing equipment jointly developed with Beijing Institute of Technology. Meeting high-performance, high-efficiency and low-cost additive manufacturing needs for complex components such as hypersonic vehicle grid rudders and medium-to-large UAV wings. Supports stainless steel, titanium alloy, aluminum alloy, high-entropy alloys, build size 3500×1500×800mm, customizable on demand.',
  },
  prodDesc: {
    medical: 'Our additive manufacturing equipment enables laser 3D printing of Class I to III medical implants, including titanium alloy dental crowns, oral stents, acetabular cup implants, spinal implants and more.',
    education: 'Our 3D printing equipment serves as core scientific research and teaching apparatus for universities and vocational colleges. It is widely applied to material analysis and scientific research in schools of materials science, STEAM innovative design, modeling design, and the development of 3D printed creative products such as intelligent robot parts, cultural and creative products, and various innovative devices. Meanwhile, it assists students majoring in industrial design, mechanics, art, architecture, medical science and other disciplines in the production and physical exhibition of graduation projects. It can also be widely used in practical teaching and skills training for majors including mould making, numerical control, and intelligent manufacturing.',
    shoeMold: '3D printed shoe sole molds are manufactured via SLM (Selective Laser Melting) using high-performance mold steel. This technology enables one-step forming of complex patterns, delicate textures, and integrated conformal cooling channels that are difficult to achieve with traditional machining. With higher precision, better detail reproduction, and greatly improved cooling efficiency, these molds significantly reduce injection and foaming cycle times while enhancing production stability and yield. Ideal for high-performance sports soles, casual shoe soles, anti-slip patterns, and complex-structured molds, they help footwear brands accelerate R&D cycles, cut modification costs, and strengthen overall product competitiveness.',
    injectionMold: '3D printed injection molds and die-casting molds are fabricated via SLM (Selective Laser Melting) using high-performance materials such as mold steel and copper alloy. They enable the production of conformal cooling channels, complex cavities, and fine textures that are difficult to achieve with traditional manufacturing. Compared with conventional molds, they deliver higher cooling efficiency, significantly shorter injection and die-casting cycles, reduced deformation and sink marks, and improved product quality and stability. Meanwhile, development and lead time are greatly shortened. Widely used in automotive, consumer electronics, medical, packaging, and daily necessities industries, they provide high-performance, flexible mold solutions for complex parts, rapid iteration, and efficient small-batch production.',
    precisionParts: '3D printed precision structural parts are manufactured with SLM metal printing technology, enabling high-precision forming of complex inner cavities, lattice lightweight structures, special-shaped channels and integrated designs that exceed traditional manufacturing limits. Featuring high dimensional accuracy, excellent surface quality and stable mechanical properties, these parts are ideal for applications demanding high complexity, lightweight design and reliability. Widely used in aerospace, automotive, medical devices, precision machinery and high-end equipment, they provide efficient solutions for rapid R&D and small-batch customization of complex components.',
  },
  advTitle: {
    manufacturingCycle: 'Manufacturing Cycle',
    materialUtilization: 'Material Utilization',
    weightReduction: 'Weight Reduction',
    complexStructures: 'Complex Structures',
    partIntegration: 'Part Integration',
    precision: 'Precision',
    density: 'Density',
    rdIteration: 'R&D Iteration',
  },
  advDesc: {
    manufacturingCycle: 'Average reduction in manufacturing cycle (no molds, fewer steps)',
    materialUtilization: 'Compared to only 10%–40% with traditional subtractive methods',
    weightReduction: 'Achieved through lattice/topology optimization',
    complexStructures: 'Minimum internal diameter for conformal cooling channels',
    partIntegration: 'Reduction in assembly points by combining multiple parts',
    precision: 'Metal printing accuracy with 0.01mm texture resolution',
    density: 'As-printed density; post heat-treatment mechanical properties approach forged standards',
    rdIteration: 'From design change to new prototype; 70% further reduction with AI generative design',
  },
  bases: {
    yantai: { name: 'Yantai HQ', role: 'Management, Capital, Material R&D Center' },
    xian: { name: "Xi'an Base", role: 'Technology, Equipment, Core Components' },
    fujian: { name: 'Fujian Base', role: 'Application, Service, Market Development' },
  },
  // Service industries (aligned with application products)
  serviceIndustries: [
    'Medical / Dental',
    'Education & Research',
    'Shoe Sole Molds',
    'Injection & Die-Casting Molds',
    'Precision Structural Parts',
  ],
  // Applications (for Home page quick links)
  applications: [
    'Aerospace', 'Marine & Shipbuilding', 'Nuclear Power',
    'UAV / Drones', 'Robotics', '3C Electronics',
    'Tire Molds', 'Metal Shoe Molds', 'Military Industry',
    'Satellite', 'Textile Machinery',
  ],
  partners: ['Hongsheng Precision Mold', 'Fujian Xingxun New Materials'],
  company: {
    fullName: 'Shandong Charmray Laser Technology Co., Ltd.',
    address: "Yantai City, Shandong Province & Xi'an City, Shaanxi Province, China",
  },

  factoryDesc: "Our company has two production bases located in Xi'an City, Shaanxi Province and Yantai City, Shandong Province respectively, with a total workshop area of 40,000 square meters. We are equipped with advanced precision inspection and testing equipment, and have established a comprehensive production and quality control system, enabling large-scale, standardized and high-quality production and delivery capabilities for 3D printing equipment and components.",
}
